<div class="row">
    <div class="col-12 mar-bot-20 loading-blocks"
        *ngFor="let loaderNum of Arr(count)" [ngClass]="'col-md-'+(12/perLine)">
        <div class="timeline-wrapper">
            <div class="timeline-item">
                <div class="animated-background">

                    <div class="background-masker content-top"></div>
                    <div class="background-masker content-second-line"></div>
                    <div class="background-masker content-third-line"></div>
                </div>
            </div>
        </div>
    </div>
</div>